// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"e9a9a3af","53":"63b05246","215":"e9a9a3af","782":"46035c81","890":"e9a9a3af","988":"e9a9a3af"}[chunkId] + ".chunk.css";
};